import React from 'react';

const locales = {
	en: {
		Active: 'Active',
		ActiveSubscriptions: "Active subscriptions",
		Add: 'Add',
		AddOrRemoveTenants: 'Add or remove tenants for selected partner to manage',
		AddOrRemovePartnerUsers: 'Add or remove users for selected partner',
		AddPartner: 'Add Partner',
		AddSubscription: 'Add Subscription',
		AddTenant: 'Add tenant',
		AdminConsent: "Admin consent",
		AdminUsers: 'Admin users',
		AdvancedSearchSettings: 'Advanced search settings',
		AdvancedSiteSettings: 'Advanced site settings',
		AllowOpenInSharePoint: 'Allow open in SharePoint',
		Amount: 'Amount',
		ApiKey: 'API key',
		ApprovalStatus: 'Approval status',
		Approved: 'Approved',
		AppLogo: 'App logo',
		AppColor: 'App color',
		AppTitle: 'App title',
		AssignedToAnother: 'Tenant assigned to another partner',
		AssignedToYou: 'Tenant is already assigned to you',
		AssignAllLicenses: 'Assign all licenses',
		Attachments: 'Attachments',
		AuthFailed: 'The sign in request could not be completed.',
		AuthKey: 'Authentication key',
		AuthProcessing: 'Processing sign-in request ...',
		AuthSecret: 'Autentication secret',
		AuthToken: 'Autentication token',
		AutoDeleteMinorVersionsOnPublish: 'Auto delete minor versions on publish',
		AutoFolderCreation: 'Auto folder creation',
		AutoSelectAttachments: 'Auto select attachments',
		AutoRemoveMailItemAttachments: 'Remove attachments from mail item on save',
		Available: 'Available',
		AvailableLicences: 'Available licences',
		AssignedLicences: 'Assigned licences',
		Bcc: 'Bcc',
		Cancel: 'Cancel',
		Canceled: 'Canceled',
		Categories: 'Categories',
		Cc: 'Cc',
		Change: 'Change',
		ClearFilter: "Clear filter",
		ClearSearch: "Clear search",
		ClearSelection: "Clear selection",
		ClickForCalendar: 'Click for Calendar',
		ClientId: "Client Id",
		ClientSecret: "Client Secret",
		Configure: 'Configure',
		Confirm: 'Confirm',
		ConsentSuccessful: "Consent successfully granted.",
		ConsentToApprovalPermissions: "Power Automate",
		ConsentToSharePointPermissions: "SharePoint",
		ConsentToUserPermissions: "User",
		ContentType: 'Content Type',
		ConversationIndex: 'Conversation-index',
		ConversationTopic: 'Conversation-topic',
		ConvertEmailToPdf: 'Convert email to pdf on save',
		Create: 'Create',
		Created: 'Created',
		DataSourceDescription: 'Manage your tenant data sources. Data sources can be set up to create a custom mapping between a data source field, and a SharePoint meta data column.',
		DataSourceFieldName: 'Datasource field name',
		DataSourceFieldNameDuplicate: 'Datasource field name already exists',
		DataSourceName: 'Data source name',
		DatasourceNumber: '{number} datasources connected',
		DataSource: 'Data source',
		DataSources: 'Data sources',
		DataSourceSettings: 'Data source settings',
		Date: 'Date',
		DateRegistered: 'Date registered',
		Deactivated: 'Deactivated',
		Default: 'Default',
		DefaultLicenseType: 'Default user license',
		Delete: 'Delete',
		DeleteWarningMessageDataSource: 'Are you sure you want to delete this datasource?',
		DeleteWarningMessageUsers: 'Are you sure you want to delete the selected user(s)?',
		Description: 'Description',
		Disabled: 'Disabled',
		DisableDocumentRename: 'Disable renaming of documents',
		DisableMailCategorization: "Disable email categorization",
		DisableAutoOpenAfterNewFileFromTemplate: "Disable new template document auto open",
		DisallowedLibraries: 'Disallowed library/list(s) eg. list1; list2',
		DisallowedSites: 'Disallowed site(s) eg. site1; site2',
		Discard: 'Discard',
		DisplayAsDropDown: 'Display as dropdown',
		DisplayName: 'Display name',
		ListGroupPropertyName: "List group property name",
		DocubirdSubscriptionReport: 'Docubird subscription report',
		DocumentLibraries: 'Document libraries',
		DocumentSet: 'Document Set',
		DocumentSettings: 'Document settings',
		Done: 'Done',
		DuplicatesFound: 'Duplicate entries found:',
		DuplicateSitesFound: 'Duplicate site names found:',
		Edit: 'Edit',
		EditDatasource: 'Edit data source',
		EditDatasourceDescription: 'Add, delete, or edit the fields for this data source.\nThe fields shown here show the mapping between a data source value and a SharePoint metadata field.',
		EditDetails: 'Edit details',
		Empty: 'Empty',
		EmailHeaderMapping: 'Email headers mapping',
		Enable: 'Enable',
		Enabled: 'Enabled',
		EnableApprovals: 'Enable approvals center',
		EnableCopyMoveTo: 'Enable copy/move to',
		EnablePermissionManagent: 'Enable management of site/library permissions',
		EnablePII: 'Enable PII',
		EnablePIIRedaction: 'Enable redaction',
		EnableNewTemplateFilters: 'Enable new template filters',
		EnableSharing: 'Enable sharing',
		EnterAuthKey: 'Enter authentication key',
		EnterAuthSecret: 'Enter authentication secret',
		EnterNewLibName: 'Enter a new library name',
		EnterNewSiteName: 'Enter a new site name',
		EnterSharepointColumn: 'Enter SharePoint column name',
		EnterUrl: 'Enter URL',
		Error: 'Error',
		ErrorAddingDatasourceMappedField: 'Error adding mapped field. Please try again.',
		Evaluation: 'Evaluation',
		ExchangeSettings: 'Exchange settings',
		Expired: 'Expired',
		ExpiryDate: 'Expiry date',
		ExportToExcel: 'Export to Excel',
		Field: 'field',
		Fields: 'fields',
		FieldName: 'Field name',
		FieldToDisplay: 'Enter field to display',
		FieldShown: '{number} {fieldOrSite} shown',
		FieldsShown: '{number} {fieldOrSite} shown',
		FieldHidden: '{number} {fieldOrSite} hidden',
		FieldsHidden: '{number} {fieldOrSite} hidden',
		File: 'File',
		Filter: 'Filter',
		FilterDateStepSince: "Since",
		FilterDateStepLast3Months: "In the last 3 months",
		FilterDateStepLast30Days: "In last 30 days",
		FilterDateStepLast7Days: "In last 7 days",
		FilterDateStepSinceYesterday: "Since yesterday",
		FilterDateStepToday: "Today",
		FilterDateStepTomorrow: "Tomorrow",
		FilterDateStepIn7Days: "In 7 days",
		FilterDateStepIn30Days: "In 30 days",
		FilterDateStepIn3Months: "In 3 months",
		FilterDateStepInAYearOrMore: "In a year or more",
		FilterUsers: 'Filter users',
		FilterTenants: 'Filter tenants',
		Folder: 'Folder',
		Free: 'Free',
		Frequency: 'Frequency',
		FriendlyName: 'Friendly name',
		From: 'From',
		GeneralSettings: "General settings",
		Hidden: 'Hidden',
		HideAutoPreview: 'Hide auto file preview',
		HideDocumentLibrariesInTeams: "Hide Teams sites document libraries",
		HideTeamsSitesInSharePoint: "Hide Teams sites under SharePoint",
		Importance: 'Importance',
		Inactive: 'Inactive',
		InfoTypesSelected: 'info types selected',
		InReplyTo: 'In reply to',
		InsideDocumentLibrary: 'Inside document library',
		InsideFolder: 'Inside folder',
		InsideDocumentSet: 'Inside document set',
		Integrations: "Integrations",
		InvalidUrl: "Invalid url value",
		Invoice: 'Invoice',
		InvoiceStatic: 'Invoice',
		InvoiceDynamic: 'Invoice dynamic',
		Manage: 'Manage',
		ManageAdvancedSearchFields: 'Manage advanced search fields to display',
		ManageDatasources: 'Manage tenant data sources',
		ManageTeamsFields: 'Manage teams to display',
		ManageSites: 'Manage sites to display',
		ManageSitesPanelInfo: 'Add, remove, or edit tenant sites',
		ManageLibraries: 'Manage libraries',
		ManageMetaData: 'Manage metadata fields to hide',
		ManagedTenants: 'Managed tenants',
		ManageSubscription: 'Manage subscription',
		MappedFields: 'Mapped fields',
		MessageId: 'Message-Id',
		MetadataColorsEdit: "Edit metadata colours",
		MetaDataColorPicker: "Metadata Color Picker",
		MetadataColorValues: "metadata colour value(s)",
		MetaDataSettings: 'Metadata settings',
		MetaDataValue: "Metadata Value",
		Method: "Method",
		MinimumVersionLimit: 'Minimum version limit',
		MinimumLicenseCharge: "A minimum of {amount} licenses will be charged",
		Monthly: 'Monthly',
		Multiselect: 'Multiselect',
		Name: 'Name',
		New: 'New',
		NewTemplateSettings: 'New template settings',
		None: 'None',
		No: 'No',
		NoAcceptedRequests: 'No accepted requests',
		NoEmptyFields: 'Fill in empty fields',
		NoFiltersAvailable: "No filters available",
		NoOptionsAvailable: 'No options available',
		NoPartner: 'No partner assigned',
		NoPendingRequests: 'No pending requests',
		NoRejectedRequests: 'No rejected requests',
		NoRoleAssigned: 'No role assigned',
		NoTenantAdmins: 'No tenant admins',
		NoTenants: 'No managed tenants',
		NoPartnerUsers: 'No partner users',
		NoSubscriptionsFound: "No subscriptions found",
		NoTenantSelected: 'No tenant selected',
		NumberOfUsers: 'Number of users',
		OcrSettings: 'OCR settings',
		OcrLanguage: 'OCR language',
		Ok: 'Ok',
		OnceOff: 'Once off',
		OpenDocumentsInClientApp: 'Open supporting documents in client application',
		OriginalSubject: 'Original subject',
		OutlookSettings: 'Outlook settings',
		Overview: 'Overview',
		OverwriteUserEmailMappings: "Do you want to overwrite all user email mappings?",
		OverwriteUsers: "Overwrite users",
		LandingPage: "Landing page",
		LastActivity: 'Last activity',
		LastActivityNone: '-',
		LibraryPanelSubtitle: 'Add, remove, or edit site libraries',
		LicenseExpiryDate: 'License expiry date',
		LicenseType: 'License type',
		LicenseCount: 'License count',
		ListName: 'List name',
		LoadingPortal: 'Loading Docubird Portal...',
		LoadingFilters: "Loading filters",
		Paid: 'Paid',
		Payments: 'Payments',
		PaymentMethod: 'Payment method',
		PaymentStatus: 'Payment status',
		Partner: 'Partner',
		Partners: 'Partners',
		PartnerUsers: 'Partner users',
		Pending: 'Pending',
		PermissionSettings: 'Permission settings',
		PIISettings: 'PII settings',
		PickColor: 'Pick color',
		Profile: 'Profile',
		PricePerLicenseMonth: "Monthly - €{price}/user/month",
		PricePerLicenseYear: "Annually - €{price}/user/month",
		Received: 'Received',
		References: 'References',
		Regenerate: 'Regenerate',
		RegenerateApiKeyWarning: 'Are you sure you want to generate a new API key? This action is irreversible.',
		Remove: 'Remove',
		Rejected: 'Rejected',
		ReplyTo: 'Reply to',
		RequiredMetadataOnPublish: 'Required metadata on publish',
		Requests: 'Requests',
		RequestDate: 'Request date',
		RequestTenant: 'Request tenant',
		RequestingPartner: 'Requesting partner',
		Reset: "Reset",
		RestrictToLibraries: 'Restrict to library/list(s) eg. list1; list2',
		RestrictToSites: 'Restrict to site(s) eg. site1; site2',
		Resume: 'Resume',
		RevokeLicenses: 'Revoke licenses',
		Role: 'Role',
		Save: 'Save',
		SaveChanges: 'Save changes',
		SaveOnSend: 'Save on send',
		SaveRequest: 'Save request',
		Search: 'Search',
		SearchSectionFilter: "Search {section} filters",
		SelectDatasourceField: 'Select datasource field',
		SelectDatasourceType: 'Select a data source type',
		SelectPartner: 'Select a partner to manage this tenant',
		SelectTenantAdmin: 'Select tenant admins',
		SelectTenant: 'Select tenant',
		SetAsPartner: 'Set user as partner',
		SelectPiiInfoTypes: 'Select PII info types',
		SelectSpecificDates: "Select specific dates",
		SelectSubscription: "Select subscription",
		SelectPaymentMethod: 'Select payment method',
		SelectWebHookTopic: 'Select service/topic',
		SetAsTenantAdmin: 'Set user as tenant admin',
		Show: 'Show',
		ShowDateRangeSlider: "Show date range slider",
		ShowLess: "Show less",
		ShowMore: "Show more",
		ShowAllFields: 'Show all fields',
		ShowAllTeams: 'Show all teams',
		ShowAllSites: 'Show all sites',
		ShowAllMetadata: 'Show all metadata fields',
		ShowAllTemplates: 'Show all templates',
		ShowAll: 'Show all',
		ShowSelected: 'Show selected',
		SignInDifferentAccount: 'Sign in with a different account',
		SignInRequest: 'Processing sign-in request...',
		SignedInUser: 'Signed-in user: ',
		SignedOutMessage: 'You have successfully signed out of the Docubird Portal application.',
		SignOut: 'Sign out',
		Site: 'site',
		Sites: 'sites',
		SitesLibrariesConfigured: '{siteCount} sites, {libraryCount} libraries configured',
		SiteName: 'Site name',
		SiteSettings: 'Site settings',
		SiteUrl: 'Site URL',
		SharepointColumnName: 'SharePoint column name(s) eg. col1, col2',
		Status: 'Status',
		Subject: 'Subject',
		Subscription: 'Subscription',
		Subscriptions: 'Subscriptions',
		SubscriptionTier: 'Subscription tier',
		SubscriptionType: 'Subscription type',
		Success: 'Success',
		Suspend: 'Suspend',
		TeamName: 'Team name',
		TeamSettings: 'Teams settings',
		Tenant: 'Tenant',
		Tenants: 'Tenants',
		TenantAdmin: 'Tenant admin',
		TenantId: 'Tenant ID',
		TenantRequestSuccess: 'Successfully requested to manage a tenant',
		Title: 'Title',
		TitleRequired: 'Title required',
		To: 'To',
		TotalRegistrations: 'Total registrations',
		TryAgain: 'Try again',
		Type: 'Type',
		Unassigned: "Unassigned",
		UnauthorizedMessage: 'You are not authorized to access the Docubird Portal application.',
		Unlimited: 'Unlimited',
		Url: 'URL',
		User: 'User',
		UserActivity: 'User activity',
		Username: 'Username',
		Users: 'Users',
		VersionSettings: 'Version settings',
		WebHookTopic: "Service/Topic to subscribe to",
		WebHookEventProcessEndpoint: "Process endpoint (url)",
		Yearly: 'Yearly',
		Yes: 'Yes',
	},
	nl: {
		Active: 'Actief',
		ActiveSubscriptions: "Actieve abonnementen",
		Add: 'Toevoegen',
		AddOrRemoveTenants: 'Tenants toevoegen of verwijderen voor geselecteerde partner om te beheren',
		AddOrRemovePartnerUsers: 'Gebruikers toevoegen of verwijderen voor geselecteerde partner',
		AddPartner: 'Partner toevoegen',
		AddSubscription: 'Abonnement toevoegen',
		AddTenant: 'Tenant toevoegen',
		AdminConsent: "Beheerderstoestemming",
		AdminUsers: 'Admin gebruikers',
		AdvancedSearchSettings: 'Geavanceerde zoekinstellingen',
		AdvancedSiteSettings: 'Geavanceerde site-instellingen',
		AllowOpenInSharePoint: 'Openen in SharePoint toestaan',
		Amount: 'Bedrag',
		ApiKey: 'API sleutel',
		ApprovalStatus: 'Goedkeuringsstatus',
		Approved: 'Goedgekeurd',
		AppLogo: 'App logo',
		AppColor: 'App kleur',
		AppTitle: 'App titel',
		AssignedToAnother: 'Tenant toegewezen aan een andere partner',
		AssignedToYou: 'Tenant is al aan u toegewezen',
		AssignAllLicenses: 'Alle licenties toewijzen',
		Attachments: 'Bijlagen',
		AuthFailed: 'Het aanmeldingsverzoek kan niet worden voltooid.',
		AuthKey: 'Verificatiesleutel',
		AuthProcessing: 'Aanmeldingsverzoek verwerken ...',
		AuthSecret: 'Authenticatiegeheim',
		AuthToken: 'Autenticatietoken',
		AutoDeleteMinorVersionsOnPublish: 'Kleine versies automatisch verwijderen bij publicatie',
		AutoFolderCreation: 'Automatische map',
		AutoSelectAttachments: 'Bijlagen automatisch selecteren',
		AutoRemoveMailItemAttachments: 'Verwijder bijlagen van e-mailitem bij opslaan',
		Available: 'Beschikbaar',
		AvailableLicences: 'Beschikbare licenties',
		AssignedLicences: 'Toegewezen licenties',
		Bcc: 'Bcc',
		Cancel: 'Annuleer',
		Canceled: 'Geannuleerd',
		Categories: 'Categorieën',
		Cc: 'Cc',
		Change: 'Verander',
		ClearFilter: "Filter wissen",
		ClearSearch: "Zoekactie verwijderen",
		ClearSelection: "Selectie wissen",
		ClickForCalendar: 'Klik voor kalender',
		ClientId: "Client-ID",
		ClientSecret: "Clientgeheim",
		Configure: 'Configureer',
		Confirm: 'Bevestig',
		ConsentSuccessful: "Toestemming succesvol verleend.",
		ConsentToApprovalPermissions: "Power Automate",
		ConsentToSharePointPermissions: "SharePoint",
		ConsentToUserPermissions: "Gebruiker",
		ContentType: 'Inhoudstype',
		ConversationIndex: 'Conversatie-index',
		ConversationTopic: 'Conversatie-onderwerp',
		ConvertEmailToPdf: 'E-mail converteren naar pdf bij opslaan',
		Create: 'Aanmaken',
		Created: 'Aangemaakt',
		DataSourceDescription: 'Beheer uw gegevensbronnen voor huurders. Gegevensbronnen kunnen worden ingesteld om een ​​aangepaste toewijzing te maken tussen een gegevensbronveld en een SharePoint-metagegevenskolom.',
		DataSourceFieldName: 'Gegevensbron veldnaam',
		DataSourceFieldNameDuplicate: 'De naam van het gegevensbronveld bestaat al',
		DataSourceName: 'Naam gegevensbron',
		DatasourceNumber: '{number} databronnen verbonden',
		DataSource: 'Data bron',
		DataSources: 'Data bronnen',
		DocumentSet: 'Documentenset',
		DataSourceSettings: 'Instellingen gegevensbron',
		Date: 'Datum',
		DateRegistered: 'Datum geregistreerd',
		Deactivated: 'Gedeactiveerd',
		Default: 'Standaard',
		DefaultLicenseType: 'Standaard gebruiker licentie',
		Delete: 'Verwijderen',
		DeleteWarningMessageDataSource: 'Weet u zeker dat u deze gegevensbron wilt verwijderen?',
		DeleteWarningMessageUsers: 'Weet je zeker dat je de geselecteerde gebruiker(s) wilt verwijderen?',
		Description: 'Beschrijving',
		Disabled: 'Uitgeschakeld',
		DisableDocumentRename: 'Hernoemen van documenten uitschakelen',
		DisableMailCategorization: "Uitschakelen van e-mailcategorisering",
		DisableAutoOpenAfterNewFileFromTemplate: "Automatisch openen van nieuw sjabloondocument uitschakelen",
		DisallowedLibraries: 'Niet toegestane bibliotheek/lijst(en), bijv. lijst1; lijst2',
		DisallowedSites: 'Niet toegestane site(s) bijv. site1; site2',
		Discard: 'Afleggen',
		DisplayAsDropDown: 'Weergeven als vervolgkeuzelijst',
		DisplayName: 'Weergavenaam',
		ListGroupPropertyName: "Lijst groep-eigenschapsnaam",
		DocubirdSubscriptionReport: 'Docubird abonnementsverslag',
		DocumentLibraries: 'Documentbibliotheken',
		DocumentSettings: 'Document-instellingen',
		Done: 'Klaar',
		DuplicatesFound: 'Dubbele vermeldingen gevonden:',
		DuplicateSitesFound: 'Dubbele sitenamen gevonden:',
		Edit: 'Bewerk',
		EditDatasource: 'Gegevensbron bewerken',
		EditDatasourceDescription: 'Voeg de velden voor deze gegevensbron toe, verwijder of bewerk deze.\nDe velden die hier worden weergegeven, tonen de toewijzing tussen een gegevensbronwaarde en een SharePoint-metagegevensveld.',
		EditDetails: 'Details bewerken',
		Empty: 'Leeg',
		EmailHeaderMapping: 'Toewijzing van e-mailheaders',
		Enable: 'Inschakelen',
		Enabled: 'Ingeschakeld',
		EnableApprovals: 'Goedkeuringscentrum inschakelen',
		EnableCopyMoveTo: 'Inschakelen kopiëren/verplaatsen naar',
		EnablePermissionManagent: 'Beheer van site/bibliotheek-rechten inschakelen',
		EnablePII: 'PII inschakelen',
		EnablePIIRedaction: 'Redactie inschakelen',
		EnableNewTemplateFilters: 'Nieuwe sjabloonfilters inschakelen',
		EnableSharing: 'Delen mogelijk maken',
		EnterAuthKey: 'Verificatiesleutel invoeren',
		EnterAuthSecret: 'Voer authenticatiegeheim in',
		EnterNewLibName: 'Voer een nieuwe bibliotheeknaam in',
		EnterNewSiteName: 'Voer een nieuwe sitenaam in',
		EnterSharepointColumn: 'Voer de naam van de SharePoint-kolom in',
		EnterUrl: 'Voer URL in',
		Error: 'Fout',
		ErrorAddingDatasourceMappedField: 'Fout bij het toevoegen van gemapt veld. Probeer het opnieuw.',
		Evaluation: 'Evaluatie',
		ExchangeSettings: 'Exchange-instellingen',
		Expired: 'Vervallen',
		ExpiryDate: 'Vervaldatum',
		ExportToExcel: 'Exporteren naar Excel',
		Field: 'veld',
		Fields: 'velden',
		FieldName: 'Veldnaam',
		FieldToDisplay: 'Veld om weer te geven',
		FieldShown: '{number} {fieldOrSite} getoond',
		FieldsShown: '{number} {fieldOrSite} getoond',
		FieldHidden: '{number} {fieldOrSite} verborgen',
		FieldsHidden: '{number} {fieldOrSite} verborgen',
		File: 'Bestand',
		Filter: 'Filter',
		FilterDateStepSince: "Sinds",
		FilterDateStepLast3Months: "In de afgelopen 3 maanden",
		FilterDateStepLast30Days: "In de afgelopen 30 dagen",
		FilterDateStepLast7Days: "In de afgelopen 7 dagen",
		FilterDateStepSinceYesterday: "Sinds gisteren",
		FilterDateStepToday: "Vandaag",
		FilterDateStepTomorrow: "Morgen",
		FilterDateStepIn7Days: "Over 7 dagen",
		FilterDateStepIn30Days: "Over 30 dagen",
		FilterDateStepIn3Months: "Over 3 maanden",
		FilterDateStepInAYearOrMore: "Over een jaar of langer",
		FilterUsers: 'Gebruikers filteren',
		FilterTenants: 'tenants filteren',
		Folder: 'Map',
		Free: 'Gratis',
		Frequency: 'Frequentie',
		FriendlyName: 'Vriendelijke naam',
		From: 'Van',
		GeneralSettings: "Algemene instellingen",
		Hidden: 'Verborgen',
		HideAutoPreview: 'Verberg automatisch bestandsvoorbeelden',
		HideDocumentLibrariesInTeams: "Verberg teamsites documentbibliotheken",
		HideTeamsSitesInSharePoint: "Verberg Teams-sites onder SharePoint",
		Importance: 'Belangrijkheid',
		Inactive: 'Inactief',
		InfoTypesSelected: 'infotypes geselecteerd',
		InReplyTo: 'Als antwoord op',
		InsideDocumentLibrary: 'In de documentenbibliotheek',
		InsideFolder: 'Binnenkant map',
		InsideDocumentSet: 'Binnenkant documentenset',
		Integrations: "Integraties",
		InvalidUrl: "Ongeldige url-waarde",
		Invoice: 'Factuur',
		InvoiceStatic: 'Factuur',
		InvoiceDynamic: 'Dynamische factuur',
		Manage: 'Beheren',
		ManageAdvancedSearchFields: 'Geavanceerde zoekvelden om weer te geven',
		ManageDatasources: 'Gegevensbronnen van huurders beheren',
		ManageTeamsFields: 'Beheer teams om weer te geven',
		ManageSites: 'Sites beheren om weer te geven',
		ManageSitesPanelInfo: 'Sites toevoegen, verwijderen of bewerken',
		ManageLibraries: 'Bibliotheken beheren',
		ManageMetaData: 'Metadatavelden beheren om te verbergen',
		ManagedTenants: 'Beheerde tenants',
		ManageSubscription: 'Abonnement beheren',
		MappedFields: 'Toegewezen velden',
		MessageId: 'E-mailbericht-Id',
		MetadataColorsEdit: "Metagegevenskleuren bewerken",
		MetaDataColorPicker: "Kleurkiezer voor metagegevens",
		MetadataColorValues: "metadata-kleurwaarde(n)",
		MetaDataSettings: 'Metadata-instellingen',
		MetaDataValue: "Metagegevenswaarde",
		Method: "Methode",
		MinimumVersionLimit: 'Minimale versielimiet',
		MinimumLicenseCharge: "Een minimum van {amount} licenties wordt in rekening gebracht",
		Monthly: 'Maandelijks',
		Multiselect: 'Meerkeuze selectie',
		Name: 'Naam',
		New: 'Nieuwe',
		NewTemplateSettings: 'Nieuwe sjablooninstellingen',
		None: 'Geen',
		No: 'Nee',
		NoAcceptedRequests: 'Geen aanvaarde verzoeken',
		NoEmptyFields: 'Vul lege velden in',
		NoFiltersAvailable: "Geen filters beschikbaar",
		NoOptionsAvailable: 'Geen opties beschikbaar',
		NoPartner: 'Geen partner toegewezen',
		NoPendingRequests: 'Geen lopende verzoeken',
		NoRejectedRequests: 'Geen afgewezen verzoeken',
		NoRoleAssigned: 'Geen rol toegewezen',
		NoTenantAdmins: 'Geen tenantbeheerders',
		NoTenants: 'Geen beheerde tenants',
		NoPartnerUsers: 'Geen partnergebruikers',
		NoSubscriptionsFound: "Geen abonnementen gevonden",
		NoTenantSelected: 'Geen tenant geselecteerd',
		NumberOfUsers: 'Aantal gebruikers',
		OcrSettings: 'OCR-instellingen',
		OcrLanguage: 'OCR-taal',
		Ok: 'Ok',
		OnceOff: 'Eenmalig',
		OpenDocumentsInClientApp: 'Open ondersteunende documenten in client toepassing',
		OriginalSubject: 'Origineel onderwerp',
		OutlookSettings: 'Outlook-instellingen',
		Overview: 'Overzicht',
		OverwriteUserEmailMappings: "Wilt u alle emailmappings van gebruikers overschrijven?",
		OverwriteUsers: "Gebruikers overschrijven",
		LandingPage: "Landingspagina",
		LastActivity: 'Laatste activiteit',
		LastActivityNone: '-',
		LibraryPanelSubtitle: 'Sitebibliotheken toevoegen, verwijderen of bewerken',
		LicenseExpiryDate: 'Licentie vervaldatum',
		LicenseType: 'Licentie type',
		LicenseCount: 'Aantal licenties',
		ListName: 'Lijstnaam',
		LoadingPortal: 'Docubird portal laden...',
		LoadingFilters: "Filters laden",
		Paid: 'Betaald',
		Payments: 'Betalingen',
		PaymentMethod: 'Betaalmethode',
		PaymentStatus: 'Betalingsstatus',
		Partner: 'Partner',
		Partners: 'Partners',
		PartnerUsers: 'Partner gebruikers',
		Pending: 'In afwachting',
		PermissionSettings: 'Rechten instellingen',
		PIISettings: 'PII-instellingen',
		PickColor: 'Kleur kiezen',
		Profile: 'Profiel',
		PricePerLicenseMonth: "Maandelijks - €{price}/gebruiker/maand",
		PricePerLicenseYear: "Jaarlijks - €{price}/gebruiker/maand",
		Received: 'Ontvangen',
		References: 'Referenties',
		Regenerate: 'Regenereren',
		RegenerateApiKeyWarning: 'Weet u zeker dat u een nieuwe API sleutel wilt genereren? Deze actie is onomkeerbaar.',
		Remove: 'Verwijderen',
		Rejected: 'Afgekeurd',
		ReplyTo: 'Antwoord aan',
		RequiredMetadataOnPublish: 'Vereiste metadata bij publicatie',
		Requests: 'Verzoeken',
		RequestDate: 'Aanvraagdatum',
		RequestTenant: 'Verzoek tenant',
		RequestingPartner: 'Verzoekende partner',
		Reset: "Annuleren",
		RestrictToLibraries: 'Beperken tot bibliotheek/lijst(en) bijv. lijst; lijst2',
		RestrictToSites: 'Beperken tot site(s) bijv. site1; site2',
		Resume: 'Hervatten',
		RevokeLicenses: 'Licenties intrekken',
		Role: 'Rol',
		Save: 'Opslaan',
		SaveChanges: 'Wijzigingen opslaan',
		SaveOnSend: 'Opslaan na sturen',
		SaveRequest: 'Verzoek opslaan',
		Search: 'Zoeken',
		SearchSectionFilter: "Zoek {section} filters",
		SelectDatasourceField: 'Selecteer gegevensbronveld',
		SelectDatasourceType: 'Selecteer een gegevensbrontype',
		SelectPartner: 'Selecteer een partner om deze tenant te beheren',
		SelectTenantAdmin: 'Selecteer tenantbeheerders',
		SelectTenant: 'Selecteer tenant',
		SetAsPartner: 'Stel de gebruiker in als partner',
		SelectPiiInfoTypes: 'Selecteer PII-infotypes',
		SelectSpecificDates: "Specifieke datums selecteren",
		SelectSubscription: "Selecteer abonnement",
		SelectPaymentMethod: 'Selecteer betaalmethode',
		SelectWebHookTopic: 'Selecteer service/onderwerp',
		SetAsTenantAdmin: 'Stel de gebruiker in als tenantbeheerder',
		SignInDifferentAccount: 'Login met een ander account',
		SignInRequest: 'Het inlogverzoek verwerken...',
		SignedInUser: 'Aangemelde gebruiker: ',
		SignedOutMessage: 'U heeft zich met succes afgemeld bij de Docubird Portal-applicatie.',
		SignOut: 'Afmelden',
		Site: 'site',
		Sites: 'sites',
		SitesLibrariesConfigured: '{siteCount} sites, {libraryCount} bibliotheken geconfigureerd',
		SiteName: 'Site naam',
		SiteSettings: 'Site-instellingen',
		SiteUrl: 'Site-URL',
		SharepointColumnName: 'SharePoint-kolomnaam(-namen) bijv. col1, col2',
		Show: 'Toon',
		ShowDateRangeSlider: "Toon datumbereik schuif",
		ShowLess: "Laat minder zien",
		ShowMore: "Laat meer zien",
		ShowAllFields: 'Toon alle velden',
		ShowAllTeams: 'Toon alle teams',
		ShowAllSites: 'Toon alle sites',
		ShowAllMetadata: 'Toon alle metadata velden',
		ShowAllTemplates: 'Toon alle sjablonen',
		ShowAll: 'Toon alles',
		ShowSelected: 'Geselecteerde tonen',
		Status: 'Status',
		Subject: 'Onderwerp',
		Subscription: 'Abonnement',
		Subscriptions: 'Abonnementen',
		SubscriptionTier: 'Abonnementsniveau',
		SubscriptionType: 'Type abonnement',
		Success: 'Succes',
		Suspend: 'Opschorten',
		TeamName: 'Teamnaam',
		TeamSettings: 'Teams-instellingen',
		Tenant: 'Tenant',
		Tenants: 'Tenants',
		TenantAdmin: 'Tenantbeheerder',
		TenantId: 'Tenant ID',
		TenantRequestSuccess: 'Met succes aangevraagd om een tenant te beheren',
		Title: 'Titel',
		TitleRequired: 'Titel vereist',
		To: 'Aan',
		TotalRegistrations: 'Totaal aantal inschrijvingen',
		TryAgain: 'Probeer het opnieuw',
		Type: 'Type',
		Unassigned: "Niet toegewezen",
		UnauthorizedMessage: 'U heeft geen toegang tot de Docubird Portal-applicatie.',
		Unlimited: 'Onbeperkt',
		Url: 'URL',
		User: 'Gebruiker',
		UserActivity: 'Gebruikersactiviteit',
		Username: 'Gebruikersnaam',
		Users: 'Gebruikers',
		VersionSettings: 'Versie-instellingen',
		WebHookTopic: "Service/Onderwerp om op te abonneren",
		WebHookEventProcessEndpoint: "Proces-eindpunt (url)",
		Yearly: 'Jaarlijks',
		Yes: 'Ja',
	},
	de: {
		Active: 'Aktiv',
		ActiveSubscriptions: "Aktive Abonnements",
		Add: 'Hinzufügen',
		AddOrRemoveTenants: 'Mandanten für den ausgewählten Partner hinzufügen oder entfernen',
		AddOrRemovePartnerUsers: 'Benutzer für den ausgewählten Partner hinzufügen oder entfernen',
		AddPartner: 'Partner hinzufügen',
		AddSubscription: 'Abonnement hinzufügen',
		AddTenant: 'Mandant hinzufügen',
		AdminConsent: "Administratorzustimmung",
		AdminUsers: 'Administratoren',
		AdvancedSearchSettings: 'Erweiterte Sucheinstellungen',
		AdvancedSiteSettings: 'Erweiterte Seiteneinstellungen',
		AllowOpenInSharePoint: 'Öffnen in SharePoint erlauben',
		Amount: 'Betrag',
		ApiKey: 'API-Schlüssel',
		ApprovalStatus: 'Genehmigungsstatus',
		Approved: 'Genehmigt',
		AppLogo: 'App-Logo',
		AppColor: 'App-Farbe',
		AppTitle: 'App-Titel',
		AssignedToAnother: 'Mandant einem anderen Partner zugewiesen',
		AssignedToYou: 'Mandant ist bereits Ihnen zugewiesen',
		AssignAllLicenses: 'Alle Lizenzen zuweisen',
		Attachments: 'Anhänge',
		AuthFailed: 'Die Anmeldung konnte nicht abgeschlossen werden.',
		AuthKey: 'Authentifizierungsschlüssel',
		AuthProcessing: 'Anfrage zur Anmeldung wird verarbeitet...',
		AuthSecret: 'Authentifizierungsgeheimnis',
		AuthToken: 'Authentifizierungstoken',
		AutoDeleteMinorVersionsOnPublish: 'Automatisches Löschen kleiner Versionen bei Veröffentlichung',
		AutoFolderCreation: 'Automatische Ordnererstellung',
		AutoSelectAttachments: 'Anhänge automatisch auswählen',
		AutoRemoveMailItemAttachments: 'Anhänge von E-Mail-Elementen beim Speichern entfernen',
		Available: 'Verfügbar',
		AvailableLicences: 'Verfügbare Lizenzen',
		AssignedLicences: 'Zugewiesene Lizenzen',
		Bcc: 'Bcc',
		Cancel: 'Abbrechen',
		Canceled: 'Abgebrochen',
		Categories: 'Kategorien',
		Cc: 'Cc',
		Change: 'Ändern',
		ClearFilter: "Filter löschen",
		ClearSearch: "Suche löschen",
		ClearSelection: "Auswahl löschen",
		ClickForCalendar: 'Klicken für Kalender',
		ClientId: "Client-ID",
		ClientSecret: "Client-Geheimnis",
		Configure: 'Konfigurieren',
		Confirm: 'Bestätigen',
		ConsentSuccessful: "Zustimmung erfolgreich erteilt.",
		ConsentToApprovalPermissions: "Power Automate",
		ConsentToSharePointPermissions: "SharePoint",
		ConsentToUserPermissions: "Benutzer",
		ContentType: 'Inhaltstyp',
		ConversationIndex: 'Konversationsindex',
		ConversationTopic: 'Konversationsthema',
		ConvertEmailToPdf: 'E-Mail beim Speichern in PDF konvertieren',
		Create: 'Erstellen',
		Created: 'Erstellt',
		DataSourceDescription: 'Verwalten Sie Ihre Mandanten-Datenquellen. Datenquellen können eingerichtet werden, um eine benutzerdefinierte Zuordnung zwischen einem Datenquellenfeld und einer SharePoint-Metadatenspalte zu erstellen.',
		DataSourceFieldName: 'Datenquellenfeldname',
		DataSourceFieldNameDuplicate: 'Datenquellenfeldname existiert bereits',
		DataSourceName: 'Datenquellenname',
		DatasourceNumber: '{number} Datenquellen verbunden',
		DataSource: 'Datenquelle',
		DataSources: 'Datenquellen',
		DataSourceSettings: 'Datenquelleneinstellungen',
		Date: 'Datum',
		DateRegistered: 'Registrierungsdatum',
		Deactivated: 'Deaktiviert',
		Default: 'Standard',
		DefaultLicenseType: 'Standardbenutzerlizenz',
		Delete: 'Löschen',
		DeleteWarningMessageDataSource: 'Möchten Sie diese Datenquelle wirklich löschen?',
		DeleteWarningMessageUsers: 'Möchten Sie den/die ausgewählten Benutzer wirklich löschen?',
		Description: 'Beschreibung',
		Disabled: 'Deaktiviert',
		DisableDocumentRename: 'Dokumentenumbennung deaktivieren',
		DisableMailCategorization: "E-Mail-Kategorisierung deaktivieren",
		DisableAutoOpenAfterNewFileFromTemplate: "Automatisches Öffnen neuer Vorlagendokumente deaktivieren",
		DisallowedLibraries: 'Nicht zugelassene Bibliothek/Liste(n), z. B. Liste1; Liste2',
		DisallowedSites: 'Nicht zugelassene Site(s), z. B. Site1; Site2',
		Discard: 'Verwerfen',
		DisplayAsDropDown: 'Als Dropdown anzeigen',
		DisplayName: 'Anzeigename',
		ListGroupPropertyName: "Name der Listengruppeneigenschaft",
		DocubirdSubscriptionReport: 'Docubird-Abonnementbericht',
		DocumentLibraries: 'Dokumentbibliotheken',
		DocumentSet: 'Dokumentenset',
		DocumentSettings: 'Dokumenteinstellungen',
		Done: 'Fertig',
		DuplicatesFound: 'Doppelte Einträge gefunden:',
		DuplicateSitesFound: 'Doppelte Seitennamen gefunden:',
		Edit: 'Bearbeiten',
		EditDatasource: 'Datenquelle bearbeiten',
		EditDatasourceDescription: 'Felder für diese Datenquelle hinzufügen, löschen oder bearbeiten.\nDie hier gezeigten Felder zeigen die Zuordnung zwischen einem Datenquellenwert und einem SharePoint-Metadatenfeld.',
		EditDetails: 'Details bearbeiten',
		Empty: 'Leer',
		EmailHeaderMapping: 'E-Mail-Header-Zuordnung',
		Enable: 'Aktivieren',
		Enabled: 'Aktiviert',
		EnableApprovals: 'Genehmigungscenter aktivieren',
		EnableCopyMoveTo: 'Kopieren/Verschieben zu aktivieren',
		EnablePermissionManagent: 'Verwaltung von Website-/Bibliotheksberechtigungen aktivieren',
		EnablePII: 'PII aktivieren',
		EnablePIIRedaction: 'Schwärzung aktivieren',
		EnableNewTemplateFilters: 'Neue Vorlagenfilter aktivieren',
		EnableSharing: 'Freigabe aktivieren',
		EnterAuthKey: 'Authentifizierungsschlüssel eingeben',
		EnterAuthSecret: 'Authentifizierungsgeheimnis eingeben',
		EnterNewLibName: 'Neuen Bibliotheksnamen eingeben',
		EnterNewSiteName: 'Neuen Seitennamen eingeben',
		EnterSharepointColumn: 'SharePoint-Spaltenname eingeben',
		EnterUrl: 'URL eingeben',
		Error: 'Fehler',
		ErrorAddingDatasourceMappedField: 'Fehler beim Hinzufügen des zugeordneten Feldes. Bitte versuchen Sie es erneut.',
		Evaluation: 'Bewertung',
		ExchangeSettings: 'Exchange-Einstellungen',
		Expired: 'Abgelaufen',
		ExpiryDate: 'Ablaufdatum',
		ExportToExcel: 'Nach Excel exportieren',
		Field: 'Feld',
		Fields: 'Felder',
		FieldName: 'Feldname',
		FieldToDisplay: 'Anzuzeigendes Feld eingeben',
		FieldShown: '{number} {fieldOrSite} angezeigt',
		FieldsShown: '{number} {fieldOrSite} angezeigt',
		FieldHidden: '{number} {fieldOrSite} ausgeblendet',
		FieldsHidden: '{number} {fieldOrSite} ausgeblendet',
		File: 'Datei',
		Filter: 'Filter',
		FilterDateStepSince: "Seit",
		FilterDateStepLast3Months: "In den letzten 3 Monaten",
		FilterDateStepLast30Days: "In den letzten 30 Tagen",
		FilterDateStepLast7Days: "In den letzten 7 Tagen",
		FilterDateStepSinceYesterday: "Seit gestern",
		FilterDateStepToday: "Heute",
		FilterDateStepTomorrow: "Morgen",
		FilterDateStepIn7Days: "In 7 Tagen",
		FilterDateStepIn30Days: "In 30 Tagen",
		FilterDateStepIn3Months: "In 3 Monaten",
		FilterDateStepInAYearOrMore: "In einem Jahr oder mehr",
		FilterUsers: 'Benutzer filtern',
		FilterTenants: 'Mandanten filtern',
		Folder: 'Ordner',
		Free: 'Kostenlos',
		Frequency: 'Frequenz',
		FriendlyName: 'Anzeigename',
		From: 'Von',
		GeneralSettings: "Allgemeine Einstellungen",
		Hidden: 'Versteckt',
		HideAutoPreview: 'Automatische Vorschau ausblenden',
		HideDocumentLibrariesInTeams: "Dokumentbibliotheken von Teams-Websites ausblenden",
		HideTeamsSitesInSharePoint: "Teams-Websites in SharePoint ausblenden",
		Importance: 'Wichtigkeit',
		Inactive: 'Inaktiv',
		InfoTypesSelected: 'Informationstypen ausgewählt',
		InReplyTo: 'Antwort auf',
		InsideDocumentLibrary: 'Innerhalb der Dokumentbibliothek',
		InsideFolder: 'Innerhalb des Ordners',
		InsideDocumentSet: 'Innerhalb des Dokumentensets',
		Integrations: "Integrationen",
		InvalidUrl: "Ungültiger URL-Wert",
		Invoice: 'Rechnung',
		InvoiceStatic: 'Rechnung',
		InvoiceDynamic: 'Rechnung dynamisch',
		Manage: 'Verwalten',
		ManageAdvancedSearchFields: 'Erweiterte Suchfelder verwalten',
		ManageDatasources: 'Mandanten-Datenquellen verwalten',
		ManageTeamsFields: 'Teams verwalten',
		ManageSites: 'Websites verwalten',
		ManageSitesPanelInfo: 'Websites hinzufügen, entfernen oder bearbeiten',
		ManageLibraries: 'Bibliotheken verwalten',
		ManageMetaData: 'Metadatenfelder zum Ausblenden verwalten',
		ManagedTenants: 'Verwaltete Mandanten',
		ManageSubscription: 'Abonnement verwalten',
		MappedFields: 'Zugeordnete Felder',
		MessageId: 'Nachrichten-ID',
		MetadataColorsEdit: "Metadatenfarben bearbeiten",
		MetaDataColorPicker: "Metadaten-Farbauswahl",
		MetadataColorValues: "Metadaten-Farbwerte",
		MetaDataSettings: 'Metadateneinstellungen',
		MetaDataValue: "Metadatenwert",
		Method: "Methode",
		MinimumVersionLimit: 'Mindestversionsgrenze',
		MinimumLicenseCharge: "Mindestens {amount} Lizenzen werden berechnet",
		Monthly: 'Monatlich',
		Multiselect: 'Mehrfachauswahl',
		Name: 'Name',
		New: 'Neu',
		NewTemplateSettings: 'Neue Vorlageneinstellungen',
		None: 'Keine',
		No: 'Nein',
		NoAcceptedRequests: 'Keine akzeptierten Anfragen',
		NoEmptyFields: 'Leere Felder ausfüllen',
		NoFiltersAvailable: "Keine Filter verfügbar",
		NoOptionsAvailable: 'Keine Optionen verfügbar',
		NoPartner: 'Kein Partner zugewiesen',
		NoPendingRequests: 'Keine ausstehenden Anfragen',
		NoRejectedRequests: 'Keine abgelehnten Anfragen',
		NoRoleAssigned: 'Keine Rolle zugewiesen',
		NoTenantAdmins: 'Keine Mandanten-Administratoren',
		NoTenants: 'Keine verwalteten Mandanten',
		NoPartnerUsers: 'Keine Partnerbenutzer',
		NoSubscriptionsFound: "Keine Abonnements gefunden",
		NoTenantSelected: 'Kein Mandant ausgewählt',
		NumberOfUsers: 'Anzahl der Benutzer',
		OcrSettings: 'OCR-Einstellungen',
		OcrLanguage: 'OCR-Sprache',
		Ok: 'Ok',
		OnceOff: 'Einmalig',
		OpenDocumentsInClientApp: 'Dokumente in der Clientanwendung öffnen',
		OriginalSubject: 'Originalbetreff',
		OutlookSettings: 'Outlook-Einstellungen',
		Overview: 'Übersicht',
		OverwriteUserEmailMappings: "Möchten Sie alle Benutzer-E-Mail-Zuordnungen überschreiben?",
		OverwriteUsers: "Benutzer überschreiben",
		LandingPage: "Startseite",
		LastActivity: 'Letzte Aktivität',
		LastActivityNone: '-',
		LibraryPanelSubtitle: 'Bibliotheken hinzufügen, entfernen oder bearbeiten',
		LicenseExpiryDate: 'Ablaufdatum der Lizenz',
		LicenseType: 'Lizenztyp',
		LicenseCount: 'Lizenzanzahl',
		ListName: 'Listenname',
		LoadingPortal: 'Docubird-Portal wird geladen...',
		LoadingFilters: "Filter werden geladen",
		Paid: 'Bezahlt',
		Payments: 'Zahlungen',
		PaymentMethod: 'Zahlungsmethode',
		PaymentStatus: 'Zahlungsstatus',
		Partner: 'Partner',
		Partners: 'Partner',
		PartnerUsers: 'Partnerbenutzer',
		Pending: 'Ausstehend',
		PermissionSettings: 'Berechtigungseinstellungen',
		PIISettings: 'PII-Einstellungen',
		PickColor: 'Farbe auswählen',
		Profile: 'Profil',
		PricePerLicenseMonth: "Monatlich - €{price}/Benutzer/Monat",
		PricePerLicenseYear: "Jährlich - €{price}/Benutzer/Monat",
		Received: 'Empfangen',
		References: 'Referenzen',
		Regenerate: 'Erneuern',
		RegenerateApiKeyWarning: 'Möchten Sie wirklich einen neuen API-Schlüssel erstellen? Diese Aktion ist irreversibel.',
		Remove: 'Entfernen',
		Rejected: 'Abgelehnt',
		ReplyTo: 'Antwort an',
		RequiredMetadataOnPublish: 'Erforderliche Metadaten bei Veröffentlichung',
		Requests: 'Anfragen',
		RequestDate: 'Anfragedatum',
		RequestTenant: 'Mandant anfragen',
		RequestingPartner: 'Anfragender Partner',
		Reset: "Zurücksetzen",
		RestrictToLibraries: 'Auf Bibliotheken/Listen beschränken, z.B. list1; list2',
		RestrictToSites: 'Auf Websites beschränken, z.B. site1; site2',
		Resume: 'Fortsetzen',
		RevokeLicenses: 'Lizenzen widerrufen',
		Role: 'Rolle',
		Save: 'Speichern',
		SaveChanges: 'Änderungen speichern',
		SaveOnSend: 'Beim Senden speichern',
		SaveRequest: 'Anfrage speichern',
		Search: 'Suchen',
		SearchSectionFilter: "Filter {section} durchsuchen",
		SelectDatasourceField: 'Datenquellenfeld auswählen',
		SelectDatasourceType: 'Datenquellentyp auswählen',
		SelectPartner: 'Wählen Sie einen Partner zur Verwaltung dieses Mandanten aus',
		SelectTenantAdmin: 'Mandantenadministratoren auswählen',
		SelectTenant: 'Mandant auswählen',
		SetAsPartner: 'Benutzer als Partner festlegen',
		SelectPiiInfoTypes: 'PII-Informationstypen auswählen',
		SelectSpecificDates: "Bestimmte Daten auswählen",
		SelectSubscription: "Abonnement auswählen",
		SelectPaymentMethod: 'Zahlungsmethode auswählen',
		SelectWebHookTopic: 'Service/Topic auswählen',
		SetAsTenantAdmin: 'Benutzer als Mandantenadministrator festlegen',
		Show: 'Anzeigen',
		ShowDateRangeSlider: "Datumsbereich-Schieberegler anzeigen",
		ShowLess: "Weniger anzeigen",
		ShowMore: "Mehr anzeigen",
		ShowAllFields: 'Alle Felder anzeigen',
		ShowAllTeams: 'Alle Teams anzeigen',
		ShowAllSites: 'Alle Websites anzeigen',
		ShowAllMetadata: 'Alle Metadatenfelder anzeigen',
		ShowAllTemplates: 'Alle Vorlagen anzeigen',
		ShowAll: 'Alle anzeigen',
		ShowSelected: 'Ausgewählte anzeigen',
		SignInDifferentAccount: 'Mit einem anderen Konto anmelden',
		SignInRequest: 'Anmeldeanforderung wird verarbeitet...',
		SignedInUser: 'Angemeldeter Benutzer: ',
		SignedOutMessage: 'Sie haben sich erfolgreich vom Docubird-Portal abgemeldet.',
		SignOut: 'Abmelden',
		Site: 'Website',
		Sites: 'Websites',
		SitesLibrariesConfigured: '{siteCount} Websites, {libraryCount} Bibliotheken konfiguriert',
		SiteName: 'Website-Name',
		SiteSettings: 'Website-Einstellungen',
		SiteUrl: 'Website-URL',
		SharepointColumnName: 'SharePoint-Spaltenname(n) z.B. col1, col2',
		Status: 'Status',
		Subject: 'Betreff',
		Subscription: 'Abonnement',
		Subscriptions: 'Abonnements',
		SubscriptionTier: 'Abonnementstufe',
		SubscriptionType: 'Abonnementtyp',
		Success: 'Erfolg',
		Suspend: 'Aussetzen',
		TeamName: 'Teamname',
		TeamSettings: 'Teameinstellungen',
		Tenant: 'Mandant',
		Tenants: 'Mandanten',
		TenantAdmin: 'Mandantenadministrator',
		TenantId: 'Mandanten-ID',
		TenantRequestSuccess: 'Mandantenverwaltung erfolgreich angefordert',
		Title: 'Titel',
		TitleRequired: 'Titel erforderlich',
		To: 'An',
		TotalRegistrations: 'Gesamtanzahl der Registrierungen',
		TryAgain: 'Erneut versuchen',
		Type: 'Typ',
		Unassigned: "Nicht zugewiesen",
		UnauthorizedMessage: 'Sie sind nicht berechtigt, auf das Docubird-Portal zuzugreifen.',
		Unlimited: 'Unbegrenzt',
		Url: 'URL',
		User: 'Benutzer',
		UserActivity: 'Benutzeraktivität',
		Username: 'Benutzername',
		Users: 'Benutzer',
		VersionSettings: 'Versions-Einstellungen',
		WebHookTopic: "Service/Topic abonnieren",
		WebHookEventProcessEndpoint: "Prozessendpunkt (URL)",
		Yearly: 'Jährlich',
		Yes: 'Ja',
	}
};

export const LanguageContext = React.createContext(locales.en);

export class LocalizationModule {
	static getLocaleStrings() {
		const localeLang = navigator.language?.toLowerCase()?.substring(0, 2) ?? "";
		switch (localeLang) {
			case "en":
				return locales.en;
			case "nl":
				return locales.nl;
			case "de":
				return locales.de;
			default:
				return locales.en;
		}
	}
}
